import { ComponentProps, useCallback, useContext } from 'react';
import { ButtonWithIcon } from 'src/components/Buttons';
import { useActivePosEntityContext } from 'src/contexts/ActivePosEntityContext';
import { ModalContext } from 'src/contexts/ModalContext';
import { vars } from 'src/core/themes';
import { ButtonProps } from 'src/core/ui';
import { ModalProps } from 'src/modals/Modal';
import { ViewCompsModal } from 'src/modals/ViewCompsModal';
import { DollarIcon, IconsFill } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';
import {
  ActionOutboxEntityType,
  ListingDetailDataField,
  ListingDetails,
} from 'src/WebApiController';

export const LaunchViewComps = ({
  listingId,
  marketplaceListingId,
  cancelTo,
  variant,
  modalSize,
  ...buttonProps
}: {
  listingId: number;
  marketplaceListingId?: string | null;
  variant?: ButtonProps['variant'];
  disabled?: boolean;
  modalSize?: ModalProps['size'];
} & ComponentProps<typeof ViewCompsModal>) => {
  const { setModal } = useContext(ModalContext);
  const { setActivePosEntity } = useActivePosEntityContext<ListingDetails>();

  const viewComps = useCallback(() => {
    setModal({
      children: <ViewCompsModal cancelTo={cancelTo} />,
      clickOutsideToClose: true,
      size: modalSize ?? 'slide-in',
      deepLinkValue: listingId,
      trackViewEntityType: ActionOutboxEntityType.Listing,
    });
  }, [setModal, cancelTo, modalSize, listingId]);

  const onLaunchDialog = useCallback(
    async (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      setActivePosEntity(listingId, marketplaceListingId, true, [
        ListingDetailDataField.Basic,
        ListingDetailDataField.Pricing,
        ListingDetailDataField.AutoPricing,
      ]);
      viewComps();
    },
    [setActivePosEntity, listingId, marketplaceListingId, viewComps]
  );

  return (
    <ButtonWithIcon
      {...buttonProps}
      variant={variant ?? 'textPlain'}
      textColor={(variant ?? 'textPlain') === 'textPlain' ? 'strong' : 'brand'}
      style={
        (variant ?? 'textPlain') === 'textPlain' ? { width: '100%' } : undefined
      }
      justifyContent="space-between"
      onClick={onLaunchDialog}
      textContentId={ContentId.ViewComps}
      icon={
        <DollarIcon
          withHoverEffect
          size={vars.iconSize.m}
          fill={
            variant && variant !== 'regular'
              ? variant === 'textPlain'
                ? IconsFill.textStrong
                : IconsFill.textBrand
              : IconsFill.textInverted
          }
        />
      }
    />
  );
};
